import Axios from 'axios'
import Servers from '../../server'
export default{
    state: {
      userObject: [],
      edit: false,
    },
    mutations: {
      setUser(state, obj){
        state.userObject = obj;
      },
      setEditUser(state, obj){
        state.edit = obj;
      }
    },
    getters: {
      getUser(state){
        return state.residentObjet
      },
      getEditUser(state){
        return state.edit
      },
    },
    actions: {
      async getAllUsers(){
       let response = await Axios.get(Servers.serverApi + "api/users/", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
        });
        return response;
      },
      async createUser(context, body){
        console.log(body)
          let response = await Axios.post(Servers.serverApi + "api/users", body, {
            responseType: "application/json",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token")
            }
          })
          return response
      }
    }
}